{
  "greeting": {
    "morning": "Dobré ráno,",
    "afternoon": "Dobré popoludnie,",
    "evening": "Dobrý večer,"
  },
  "selectDate": "Vybrať dátum"
}
